import { LitElement } from '~/lib/bn-lit-element';
import { html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';

class BinProbationExplanationModal extends BnModalMixin(LitElement) {
  constructor() {
    super();
    this.id = 'bin-probation-explanation-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#bin-probation-explanation-modal {
          --modal-min-width: 75%;
          --modal-max-width: 500px;
        }
        h3 {
          margin: 0;
        }
        ul {
          margin-top: 0.25rem;
          padding-left: 2rem;
        }
      </style>

      <h3 slot="title">Info: Probation</h3>

      <h3>What Is Probation?</h3>
      <ul>
        <li>Probation is the two week period starting from the time of installation. </li>
        <li>When the probationary period is over all reported data is reviewed by a BinSentry service manager.</li>
      </ul>

      <h3>Why have a Probationary Period?</h3>
      <ul>
        <li>Any issues that may occur are most likely to appear during the probationary period.</li>
        <li>During the period we would especially appreciate your insight and analysis to help us determine if the sensor is behaving as expected.</li>
        <li>Any concerns you may have with this bin or the reported data can be reported via the "Report a Concern" button.</li>
      </ul>

      <h3>Is the Data Safe to Use?</h3>
      <ul>
        <li>98% of devices pass probation with no problem so the data is likely fine, however it is still advised to scrutinize the data more closely during probation. </li>
      </ul>
    `;
  }
}

window.customElements.define('bin-probation-explanation-modal', BinProbationExplanationModal);
